import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { empresaService } from '../services/empresaService';

/**
 * Bloqueia tenants de empresas com status `suspenso`.
 * super_admin ignora esta verificação (suporte cross-tenant).
 */
export default function TenantStatusGuard() {
  const { role, empresaId, loading } = useAuth();
  const [status, setStatus] = useState<'loading' | 'ativo' | 'suspenso' | 'erro'>('loading');
  const [tentativa, setTentativa] = useState(0);

  useEffect(() => {
    if (loading) return;
    if (role !== 'tenant' || !empresaId) {
      setStatus('ativo');
      return;
    }

    let cancelled = false;
    setStatus('loading');
    empresaService.buscarStatus(empresaId)
      .then(s => {
        if (cancelled) return;
        setStatus(s === 'suspenso' ? 'suspenso' : 'ativo');
      })
      .catch(() => {
        if (!cancelled) setStatus('erro');
      });

    return () => { cancelled = true; };
  }, [loading, role, empresaId, tentativa]);

  if (loading || status === 'loading') {
    return (
      <div className="fixed inset-0 bg-slate-950 flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-orange-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (status === 'suspenso') {
    return <Navigate to="/conta-suspensa" replace />;
  }

  // Falha ao consultar: não libera (antes caía no Outlet — um tenant suspenso
  // com rede instável ou erro de RLS entrava normalmente no painel).
  if (status === 'erro') {
    return (
      <div className="fixed inset-0 bg-slate-950 flex flex-col items-center justify-center gap-4 px-4 text-center">
        <p className="text-sm text-slate-300">Não foi possível verificar sua conta.</p>
        <button
          type="button"
          onClick={() => setTentativa(t => t + 1)}
          className="rounded-xl bg-white/[0.08] px-4 py-2.5 text-sm font-semibold text-white"
        >
          Tentar novamente
        </button>
      </div>
    );
  }

  return <Outlet />;
}
